import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import {
  TournamentEntry,
  PracticeGameEntry,
} from "@nestcoinco/hyper-api-gateway-api-client";

import { STORED_ATOM_KEYS } from "../constants";

const duelEntrySessionStorageJson = createJSONStorage<TournamentEntry | null>(
  () => sessionStorage
);
export const duelEntryAtomWithStorage = atomWithStorage<TournamentEntry | null>(
  STORED_ATOM_KEYS.DUEL_ENTRY,
  null,
  duelEntrySessionStorageJson,
  { getOnInit: true }
);
duelEntryAtomWithStorage.debugLabel = "duel-entry-stored";

export interface IOpponentSummary {
  username: string;
  avatar: string;
}

const duelOpponentSessionStorageJson =
  createJSONStorage<IOpponentSummary | null>(() => sessionStorage);
export const duelOpponentAtomWithStorage =
  atomWithStorage<IOpponentSummary | null>(
    STORED_ATOM_KEYS.DUEL_OPPONENT,
    null,
    duelOpponentSessionStorageJson,
    { getOnInit: true }
  );
duelOpponentAtomWithStorage.debugLabel = "duel-opponent-stored";

const practiceGameEntrySessionStorageJson =
  createJSONStorage<PracticeGameEntry | null>(() => sessionStorage);

export const practiceGameEntryAtom = atomWithStorage<PracticeGameEntry | null>(
  STORED_ATOM_KEYS.PRACTICE_GAME_ENTRY,
  null,
  practiceGameEntrySessionStorageJson,
  { getOnInit: true }
);
practiceGameEntryAtom.debugLabel = "practice-game-entry-stored";

export const currentPendingTournamentEntryAtom = atom<TournamentEntry>();
currentPendingTournamentEntryAtom.debugLabel =
  "current-pending-tournament-entry";
